
import React, { PureComponent } from 'react';
import InputClearifier from '../component/InputClarifier';

import Language from 'services/Language.js';

class ModalCaptchaForm extends PureComponent {

    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCaptchaReload = this.handleCaptchaReload.bind(this);
        this.state = {
            text: "",
            timeUntilCall: 0,
            timeUntilCallFinished: false,
            prevProps: null,
            captchaIndex: 1,
            isUsePrevProps: false,
            captchaRandom1: null,
            captchaRandom2: null,
            isInvalid: false
        };
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.text) {
            this.refs.input.refs.input.focus();
            this.setState({
                isInvalid: true,
            });
            return;
        }
        this.props.onSubmit({
            text: this.state.text,
            handlerId: this.props.handlerId,
        });
    }

    handleChange(event) {
        this.setState({
            text: event.target.value,
        });
    }

    handleCaptchaReload() {
        const newCaptchaIndex = this.state.captchaIndex === 1 ? 2 : 1;
        this.setState({
            isUsePrevProps: true,
            captchaIndex: newCaptchaIndex,
            captchaRandom1: newCaptchaIndex === 1 ? null : this.state.captchaRandom1,
            captchaRandom2: newCaptchaIndex === 2 ? null : this.state.captchaRandom2,
        });
        this.props.onCaptchaReload();
    }

    static getDerivedStateFromProps(props, state) {
        const prevProps = state.prevProps;
        const prevState = state.prevState;

        return {
            isInvalid: (prevState && state.isInvalid) ? prevState.pin === state.pin : state.isInvalid,

            captchaRandom1: ((!prevProps || props.captchaRandom !== prevProps.captchaRandom) && state.captchaIndex === 1) ? props.captchaRandom : state.captchaRandom1,
            captchaRandom2: ((!prevProps || props.captchaRandom !== prevProps.captchaRandom) && state.captchaIndex === 2) ? props.captchaRandom : state.captchaRandom2,
            isUsePrevProps: state.isUsePrevProps ? props.captchaRandom === prevProps.captchaRandom : state.isUsePrevProps,
            timeUntilCall: (prevProps && prevProps.timeUntilCallFinished !== props.timeUntilCallFinished && props.timeUntilCallFinished) ? props.timeUntilCall : state.timeUntilCall,
            timeUntilCallFinished: props.timeUntilCallFinished,
            prevProps: props,
            prevState: state
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.disableTabs !== this.props.disableTabs &&
            !!prevProps.disableTabs) {
            $(this.refs.container).find(':focus').blur();
        }
    }

    getTabIndex() {
        return this.props.disableTabs ? "-1" : "";
    }

    getPending() {
        return !!this.props.pending;
    }

    render() {
        /*
            this.props.handlerId
            this.props.disableTabs

            this.props.
        */

        return (
            <div ref="container">
                <form onSubmit={this.handleSubmit}>
                    <h3 className='captcha-title' dangerouslySetInnerHTML={{ __html: Language.getLabel('L_CONFIRM_HEADER_CAPTCHA') }}>
                    </h3>
                    <div className="pale-hint text-center" dangerouslySetInnerHTML={{ __html: Language.getLabel('L_CONFIRM_SUB_HEADER_CAPTCHA') }}>
                    </div>
                    <div className="modal-auth-form light-block">
                        <div className="row mb-3 row-form">
                            <div className="col-7 captcha-box">
                                <div className="captcha-box__caption pale-hint">
                                    {Language.getLabel('L_PLEASE_WAIT')}
                                </div>
                                <div>
                                    {this.state.captchaIndex === 1 && !this.state.isUsePrevProps &&
                                        !!this.state.captchaRandom1 &&
                                        <img key="1"
                                            ref="captcha"
                                            className="captcha-image"
                                            src={this.props.settings.captchaImg + '?rd=' + this.props.captchaRandom}
                                            alt="Captcha"
                                        />
                                    }
                                </div>
                                <div>
                                    {this.state.captchaIndex === 2 && !this.state.isUsePrevProps &&
                                        !!this.state.captchaRandom2 &&
                                        <img key="2"
                                            ref="captcha"
                                            className="captcha-image"
                                            src={this.props.settings.captchaImg + '?rd=' + this.props.captchaRandom}
                                            alt="Captcha"
                                        />
                                    }
                                </div>
                            </div>
                            <div className="col-5">
                                <button className="btn btn_large btn_black-and-white btn_full-width btn-outline-secondary"
                                    type="button"
                                    disabled={this.getPending()}
                                    tabIndex={this.getTabIndex()}
                                    onClick={this.handleCaptchaReload}>
                                    {Language.getLabel('L_REFRESH')}
                                </button>
                            </div>
                        </div>
                        <InputClearifier
                            ref="input"
                            onChange={this.handleChange}
                            placeholder={Language.getLabel('L_CONFIRM_PLACEHOLDER_CAPTCHA')}
                            additionalClassName={`${this.state.isInvalid ? 'is-invalid' : ''} ${sl.captchaPopup__textInput}`}
                            name="text"
                            value={this.state.phone}
                            tabIndex={this.getTabIndex()}
                            disabled={this.getPending()}
                        />
                    </div>
                    <div>
                        <button className={`btn solid-button btn_full-width solid-button_lg mb-2 ${sl.captchaPopup__submitButton}`}
                            tabIndex={this.getTabIndex()}
                            disabled={this.getPending()}
                            type="submit">
                            {this.props.isLast ?
                                Language.getLabel('L_SEND') :
                                Language.getLabel('L_NEXT')
                            }
                        </button><button className="btn solid-button btn_full-width solid-button_lg solid-button_transparent"
                            tabIndex={this.getTabIndex()}
                            disabled={this.getPending()}
                            onClick={this.props.onCancel}
                            type="button"
                            data-dismiss="modal">
                            {Language.getLabel('L_CANCEL')}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default ModalCaptchaForm;